import axios from 'axios';
import { z } from 'zod';

import { strictQuery } from 'utils/strict-query';

const AnswersApi = {
    getAnswers: strictQuery({
        In: z.object({ id: z.number(), path: z.string().optional() }),
        Out: z.any(),
        handler: ({ id, path = '' }) => axios.get(`/qinstances/${id}/answers`, { params: { path } }),
    }),
    putAnswers: strictQuery({
        In: z.object({ id: z.number(), answers: z.any(), path: z.string().optional(), source: z.string().optional() }),
        Out: z.any(),
        handler: ({ id, answers, path = '', source = '' }) =>
            axios.put(`/qinstances/${id}/answers`, answers, { params: { path, source } }),
    }),
    getCommonAnswers: strictQuery({
        In: z.string().optional(),
        Out: z.any(),
        handler: (type = '') => axios.get(`/questionnaires/common-answers`, { params: { type } }),
    }),
    deleteAnswers: strictQuery({
        In: z.object({ id: z.number(), path: z.string() }),
        Out: z.any(),
        handler: ({ id, path }) => axios.delete(`/qinstances/${id}/answers`, { params: { path } }),
    }),
    autofillAnswers: strictQuery({
        In: z.object({ qInstanceId: z.number(), path: z.string() }),
        Out: z.any(),
        handler: ({ qInstanceId, path }) =>
            axios.patch(`/qinstances/${qInstanceId}/answers/autofill`, null, { params: { path } }),
    }),
};

export default AnswersApi;
